import React, { useState } from "react";
import { Link } from "react-router-dom";

const Wheel = () => {
  const [minNumber, setMinNumber] = useState(0);
  const [maxNumber, setMaxNumber] = useState(10);
  const [angle, setAngle] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);

  const numbers = Array.from(
    { length: maxNumber - minNumber + 1 },
    (_, i) => i + minNumber
  );
  const segmentAngle = 360 / numbers.length;

  const initialRotation = -segmentAngle / 2;
  const spinWheel = () => {
    if (spinning) return;

    const randomRotation = 360 * 5 + Math.floor(Math.random() * 360);
    const finalAngle = (angle + randomRotation) % 360;

    const stopperOffset = segmentAngle / 2;
    const adjustedAngle =
      Math.round(finalAngle / segmentAngle) * segmentAngle - stopperOffset;

    setAngle(angle + randomRotation + (adjustedAngle - finalAngle));
    setSpinning(true);

    setTimeout(() => {
      setSpinning(false);

      const index =
        Math.floor((360 - adjustedAngle + segmentAngle / 2) / segmentAngle) %
        numbers.length;
      const selectedId = numbers[index];
      setSelectedNumber(selectedId);
      setShowPopup(true);
      console.log("Wheel stopped at ID:", selectedId);
    }, 3000);
  };

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <p className="text-sm pb-5">
        {" "}
        if you need Max Number Greater Then 100 Then{" "}
        <Link to="/spinner" className="text-green-400 font-semibold">
          {" "}
          Click Here
        </Link>{" "}
      </p>
      <h1 className="text-xl md:text-3xl font-bold text-gray-700 mb-8">
        Dynamic Spinner Add value According To You. Max value limit is 100
      </h1>
      <div className="relative tx-rotate">
        <div
          className="w-60 h-60 md:w-[40rem] md:h-[40rem] rounded-full border-4 border-gray-300 flex items-center justify-center "
          style={{
            transform: `rotate(${angle + initialRotation}deg)`,
            transition: "transform 3s cubic-bezier(0.2, 0.99, 0.3, 1.0)",
          }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 200 200"
            className="absolute"
          >
            {numbers.map((num, i) => {
              const angleStart = (i / numbers.length) * 2 * Math.PI;
              const angleEnd = ((i + 1) / numbers.length) * 2 * Math.PI;
              return (
                <path
                  key={i}
                  id={`segment-${num}`}
                  d={`M 100 100 L ${100 + 100 * Math.cos(angleStart)} ${
                    100 + 100 * Math.sin(angleStart)
                  }
                      A 100 100 0 0 1 ${100 + 100 * Math.cos(angleEnd)} ${
                    100 + 100 * Math.sin(angleEnd)
                  }
                      Z`}
                  fill={`hsl(${(i / numbers.length) * 360}, 80%, 60%)`}
                  stroke="white"
                  strokeWidth="2"
                />
              );
            })}
          </svg>
          {numbers.map((num, i) => {
            const anglePos = ((i + 0.5) / numbers.length) * 2 * Math.PI;
            return (
              <div
                key={i}
                className={`absolute text-[14px] font-bold ${
                  selectedNumber === num ? "text-white scale-125" : "text-black"
                } transition-transform duration-300`}
                style={{
                  top: `${50 + 40 * Math.sin(anglePos)}%`,
                  left: `${50 + 40 * Math.cos(anglePos)}%`,
                  transform: "translate(-50%, -50%)",
                }}
              >
                {num}
              </div>
            );
          })}
          <div className="absolute w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg">
            🎯
          </div>
        </div>
      </div>

      <button
        onClick={spinWheel}
        className="mt-16 px-6 py-3 bg-[#31c48d] text-white rounded-lg text-lg font-medium transition"
        disabled={spinning}
      >
        {spinning ? "Spinning..." : "Spin the Wheel"}
      </button>

      <div className="mt-16">
        <div className="flex gap-4 mb-4">
          <div>
            <span className="mr-5">Min Number :</span>
            <input
              type="number"
              value={minNumber}
              onChange={(e) =>
                setMinNumber(Math.max(1, Number(e.target.value)))
              }
              className="border p-2 rounded w-20 text-center"
              min="1"
            />
          </div>

          <div>
            <span className="mr-5">Max Number :</span>
            <input
              type="number"
              value={maxNumber}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value > 100) {
                  alert("Max value can't be greater than 100");
                  return;
                }
                setMaxNumber(Math.max(minNumber + 1, value));
              }}
              className="border p-2 rounded w-20 text-center"
              min={minNumber + 1}
            />
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-[2000]">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-bold">Random Number !</h2>
            <p className="text-lg mt-2">
              You got:{" "}
              <span className="text-green-500 font-bold">{selectedNumber}</span>
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className="mt-4 px-4 py-2 bg-green-700 text-white rounded-lg"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wheel;
